import {MasterReport} from "./reports";

export type ReportSelectParameter = "data_type" | "access_type" | "access_method" | "metric_type"
export type ReportParameter = "yop" | "granularity" | ReportSelectParameter;

export interface ParameterOption {
  value: string;
  name: string;
}

type ParameterOptions = { [P in ReportSelectParameter]: ParameterOption[] }

export const dataTypes = {
  BookSegment: {
    value: "Book_Segment",
    name: "Book_Segment"
  },
  Database: {
    value: "Database",
    name: "Database"
  },
  Article: {
    value: "Article",
    name: "Article"
  },
  Book: {
    value: "Book",
    name: "Book"
  },
  Journal: {
    value: "Journal",
    name: "Journal"
  },
  Multimedia: {
    value: "Multimedia",
    name: "Multimedia"
  },
  Image: {
    value: "Image",
    name: "Image"
  },
  Sound: {
    value: "Sound",
    name: "Sound"
  },
  Audiovisual: {
    value: "Audiovisual",
    name: "Audiovisual"
  },
  // Not actually supported, only for compliance:
  Reference_Work: {
    value: "Reference_Work",
    name: "Reference_Work"
  },
  Interactive_Resource: {
    value: "Interactive_Resource",
    name: "Interactive_Resource"
  }
};

export const accessTypes = {
  Controlled: {
    value: "Controlled",
    name: "Controlled"
  },
  OaGold: {
    value: "Open",
    name: "Open"
  },
  OtherFreeToRead: {
    value: "Free_To_Read",
    name: "Free_To_Read"
  }
};

export const accessMethods = {
  Regular: {
    value: "Regular",
    name: "Regular"
  },
  // Not actually supported, only for compliance:
  TDM: {
    value: "TDM",
    name: "TDM"
  }
};

export const metricTypes = {
  TotalItemInvestigations: {
    value: "Total_Item_Investigations",
    name: "Total_Item_Investigations"
  },
  TotalItemRequests: {
    value: "Total_Item_Requests",
    name: "Total_Item_Requests"
  },
  UniqueItemInvestigations: {
    value: "Unique_Item_Investigations",
    name: "Unique_Item_Investigations"
  },
  UniqueItemRequests: {
    value: "Unique_Item_Requests",
    name: "Unique_Item_Requests"
  },
  UniqueTitleInvestigations: {
    value: "Unique_Title_Investigations",
    name: "Unique_Title_Investigations"
  },
  UniqueTitleRequests: {
    value: "Unique_Title_Requests",
    name: "Unique_Title_Requests"
  },
  LimitExceeded: {
    value: "Limit_Exceeded",
    name: "Limit_Exceeded"
  },
  NoLicense: {
    value: "No_License",
    name: "No_License"
  },
  SearchesPlatform: {
    value: "Searches_Platform",
    name: "Searches_Platform"
  },
  SearchesAutomated: {
    value: "Searches_Automated",
    name: "Searches_Automated"
  },
  SearchesFederated: {
    value: "Searches_Federated",
    name: "Searches_Federated"
  },
  SearchesRegular: {
    value: "Searches_Regular",
    name: "Searches_Regular"
  }
};

// Only the four master reports allow you to specify filters
export const paramOptions: Record<MasterReport, ParameterOptions> = {
  TR: {
    data_type: [
      dataTypes.Book,
      dataTypes.Journal,
      dataTypes.Reference_Work
    ],
    access_type: Object.values(accessTypes),
    access_method: Object.values(accessMethods),
    metric_type: [
      metricTypes.TotalItemInvestigations,
      metricTypes.TotalItemRequests,
      metricTypes.UniqueItemInvestigations,
      metricTypes.UniqueItemRequests,
      metricTypes.UniqueTitleInvestigations,
      metricTypes.UniqueTitleRequests,
      metricTypes.LimitExceeded,
      metricTypes.NoLicense
    ]
  },

  DR: {
    data_type: [
      dataTypes.Database,
      dataTypes.Book,
      dataTypes.Journal,
      dataTypes.Image,
      dataTypes.Sound,
      dataTypes.Audiovisual,
      dataTypes.Multimedia,
      dataTypes.Reference_Work,
      dataTypes.Interactive_Resource
    ],
    access_type: [],
    access_method: Object.values(accessMethods),
    metric_type: [
      metricTypes.SearchesAutomated,
      metricTypes.SearchesFederated,
      metricTypes.SearchesRegular,
      metricTypes.TotalItemInvestigations,
      metricTypes.TotalItemRequests,
      metricTypes.UniqueItemInvestigations,
      metricTypes.UniqueItemRequests,
      metricTypes.UniqueTitleInvestigations,
      metricTypes.UniqueTitleRequests,
      metricTypes.LimitExceeded,
      metricTypes.NoLicense
    ]
  },

  PR: {
    data_type: [
      dataTypes.BookSegment,
      dataTypes.Database,
      dataTypes.Article,
      dataTypes.Book,
      dataTypes.Journal,
      dataTypes.Image,
      dataTypes.Sound,
      dataTypes.Audiovisual,
      dataTypes.Multimedia,
      dataTypes.Interactive_Resource,
      dataTypes.Reference_Work
    ],
    access_type: [],
    access_method: Object.values(accessMethods),
    metric_type: [
      metricTypes.SearchesPlatform,
      metricTypes.TotalItemInvestigations,
      metricTypes.TotalItemRequests,
      metricTypes.UniqueItemInvestigations,
      metricTypes.UniqueItemRequests,
      metricTypes.UniqueTitleInvestigations,
      metricTypes.UniqueTitleRequests
    ]
  },

  IR: {
    data_type: [
      dataTypes.BookSegment,
      dataTypes.Article,
      dataTypes.Book,
      dataTypes.Journal,
      dataTypes.Image,
      dataTypes.Sound,
      dataTypes.Audiovisual,
      dataTypes.Multimedia,
      dataTypes.Interactive_Resource
    ],
    access_type: Object.values(accessTypes),
    access_method: Object.values(accessMethods),
    metric_type: [
      metricTypes.TotalItemInvestigations,
      metricTypes.TotalItemRequests,
      metricTypes.UniqueItemInvestigations,
      metricTypes.UniqueItemRequests,
      metricTypes.LimitExceeded,
      metricTypes.NoLicense
    ]
  }
};
